import React from 'react'
import { Link } from 'react-router-dom'
import styles from './index.module.css'
type Props = {
  source: {
    sourceLink?: string
    sourceText: string
  }
}
export default function SourceLink({ source }: Props): React.ReactNode {
  if (source.sourceLink) {
    return (
      <Link
        className={`inline-link ${styles.SourceLink}`}
        to={source.sourceLink}
      >
        {source.sourceText}
      </Link>
    )
  } else {
    return <span>{source.sourceText}</span>
  }
}
